export enum ApiKeyStatus {
    Unknown = 0,
    Active = 2,
    Archived = 3
}